import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style: CSSResult = css`
  :host {
    display: flex;
    flex-flow: column;
    gap: ${csSpacing.spacing06};
  }

  cse-list {
    --cse-list-gap: ${csSpacing.spacing06};
    --cse-list-row-gap: ${csSpacing.spacing06};
  }

  .checkbox-wrapper {
    width: 100%;
    display: flex;
  }

  .item {
    width: 100%;
  }
`
